/* eslint-disable quotes */
import './DebugVars.scss';
import { defineComponent, h } from "vue";
import { Modal } from '@phi/components';
import { saveDebugVars } from '../../debug';

const body = `<div id="debugvarshtml">...</div>

<p><button type="button" class="btn btn--primary" id="saveDebugVars" onclick="saveDebugVars()">Save</button></p>`;

export default defineComponent({
    props: {
        show: { required: true, type: Boolean},
    },

    emits: {
        'update:show': (x: boolean) => true,
    },

    watch: {
        show(value) {
            if (value)
                document.documentElement.addEventListener('keydown', this.onEnter);
            else
                document.documentElement.removeEventListener('keydown', this.onEnter);
        }
    },

    methods: {
        onEnter(e: KeyboardEvent) {
            if (e.key !== 'Enter') return;
            saveDebugVars();
            this.$emit('update:show', false);
        },
    },

    render() {
        return h(Modal, {
            show: this.show,
            'onUpdate:show': (x) => this.$emit('update:show', x),
            id: 'DebugVarsModal',
            title: 'Debug vars',
            unload: false,
        }, {
            body: () => h('div', { innerHTML: body }),
            footer: () => h('button', {
                class: 'btn',
                onClick: () => this.$emit('update:show', false),
            }, 'Close'),
        });
    }
});
